import api from "./core";

const basePath = "api/{{serverSegment}}/Documents";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  getForAdvancedFormControl(id) {
    return api.get(`${basePath}/forAdvancedFormBuilderControl/${id}`);
  },
  getDetailed(id) {
    return api.get(`${basePath}/GetDetailed/${id}`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  bulkUpdate(data) {
    return api.patch(`${basePath}/BulkComplete`, data);
  },
  updateAndComplete(id, data) {
    return api.patch(`${basePath}/${id}/SaveAndComplete`, data);
  },
  revert(id) {
    return api.patch(`${basePath}/${id}/RevertComplete`);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(formId, clientId, eocId) {
    return api.post(`${basePath}/ByEoc/${formId}/${eocId}`);
  },
  queryForAdvancedFormBuilderComponent(formId, clientId, eocId) {
    return api.get(
      `${basePath}/ByEocForAdvancedFormBuilderComponent/${formId}/${eocId}`
    );
  },
  queryByCateg(category, clientId, eocId) {
    return api.post(`${basePath}/ByEocAndCategory/${category}/${eocId}`);
  },
  create(data, sharedDocumentId = null) {
    return api.put(
      `${basePath}${sharedDocumentId ? `/${sharedDocumentId}` : ""}`,
      data
    );
  },
  createAndComplete(data) {
    return api.put(`${basePath}/CreateAndComplete`, data);
  },
  upload(data) {
    const {
      file,
      clientId,
      formId,
      date,
      eocId,
      submitId,
      status,
      scheduleEventId,
      attachForm,
    } = data;
    const formData = new FormData();
    formData.append("File", file);
    formData.append("PatientId", clientId);
    formData.append("FormId", formId);
    formData.append("EffectiveDate", date);
    formData.append("EpisodeOfCareId", eocId);
    formData.append("Status", status);
    if (attachForm) formData.append("ScheduleEventId", scheduleEventId);
    formData.append("AttachForm", attachForm);
    if (submitId) formData.append("id", submitId);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return api.put(`${basePath}/upload`, formData, config);
  },
  uploadUpdate(data) {
    const { file, date, submitId, status, formId, unlockReason } = data;
    const formData = new FormData();
    if (file) formData.append("File", file);
    formData.append("EffectiveDate", date);
    formData.append("Status", status);
    formData.append("FormId", formId);
    formData.append("UnlockReason", unlockReason);
    if (submitId) formData.append("id", submitId);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return api.patch(`${basePath}/upload`, formData, config);
  },
  viewUrl(id) {
    return `${api.getFormsBaseUrl()}${basePath}/Download/${api.getToken()}/${id}`;
  },
  setScore(id, data) {
    return api.patch(`${basePath}/SetScore/${id}`, data);
  },
};
